import axios from "../../../axios/index.js"

function shouldSkipAuthRefresh(config) {
  if (!config) return false
  if (config.skipAuthRefresh) return true
  const url = config.url || ''
  return url.includes('SelfService/session-events')
}

export default {
  init() {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      const { config, response } = error

      if (response && response.status === 401 && shouldSkipAuthRefresh(config)) {
        return Promise.reject(error)
      }

      return Promise.reject(error)
    })
  },
  login(userName, pwd) {
    return axios.post("/auth/login", {userName: userName, password: pwd})
  },
  registerUser(name, email, pwd) {
    return axios.post("/auth/register", {displayName: name, email: email, password: pwd})
  },
  refreshToken() {
    return Promise.reject(new Error('refresh-token endpoint is not available'))
  }
}
